$(document).ready(function(){
	$(document).on("click",".js_show-more-datatable", function(){
		$(this).closest("tr").find('.inactive').fadeToggle();
	});
});
